// ---- Games over appreciation text
export const GamesOverText = {
    LOST: "C'est perdu",
    SUCCESS: "Tu as gagné",
    RECORD: "Tu as battu mon record\u00A0!"
}